<template>
  <div id="app" :key="$i18n.locale">
    <headers />
    <router-view></router-view>
    <transition name="fade">
      <a
        class="wa-float"
        href="https://d.salesmartly.com/fv7wyq"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="./assets/mo/whatsapp.png"
          alt=""
          style="width: 80%; height: 80%"
        />
      </a>
    </transition>
    <foots />
  </div>
</template>
<script>
import foots from "@/components/foots.vue";
import headers from "@/components/headers.vue";
export default {
  components: { headers, foots },

  data() {
    return {};
  },
  mounted() {},
  beforeDestroy() {},
  methods: {},
};
</script>

<style lang="scss">
/* 1. 淡入淡出过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  /* 底部向上滑入效果 */
  transform: translateY(20px);
}
/* WhatsApp悬浮按钮 永久呼吸闪烁 */
.wa-float {
  position: fixed;
  right: 30rpx;
  bottom: 120rpx;
  width: 100rpx;
  height: 100rpx;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4rpx 16rpx rgba(37, 211, 102, 0.4);
  z-index: 999;
  transition: transform 0.2s, background 0.2s;
  /* 永久循环呼吸动画 */
  animation: pulse 2s infinite ease-in-out;
}

/* 呼吸扩散光晕动画 */
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7);
  }
  70% {
    box-shadow: 0 0 0 24rpx rgba(37, 211, 102, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
  }
}

/* transition fade淡入淡出 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
* {
  margin: 0;
  padding: 0;
}
body,
html {
  width: 100%;
  overflow-x: auto;
  padding: 0 !important;
}
</style>
